module.exports = __webpack_public_path__ + "img/sparkasse-vorpommern.5ad70c57.png";